/**
 * Content Configuration
 *
 * Centralized text content for easy updates and localization.
 */

export const HERO_CONTENT = {
  preHeadline: 'PixelMinds Consultancy',
  headline: 'Transforming Ideas Into Digital Reality',
  subheadline:
    'We partner with forward-thinking businesses to deliver innovative technology solutions that drive growth, efficiency, and competitive advantage in the digital age.',
  primaryCta: 'Get Started',
  secondaryCta: 'Explore Our Solutions',
};

export const ABOUT_CONTENT = {
  subtitle: 'About Us',
  title: 'Who We Are',
  paragraphs: [
    'PixelMinds Consultancy LTD is a UK-based technology consulting firm dedicated to transforming how businesses operate in the digital landscape. Founded on the principles of innovation, integrity, and excellence, we bring together a team of seasoned technologists and creative problem-solvers.',
    "With over a decade of experience across diverse industries, we've successfully delivered enterprise-grade solutions that have helped organisations streamline operations, enhance customer experiences, and unlock new revenue streams.",
    'Our commitment to staying at the forefront of emerging technologies—from artificial intelligence to cloud-native architectures—ensures that our clients always have access to the most effective and future-proof solutions available.',
  ],
};

export const SERVICES_CONTENT = {
  subtitle: 'Our Services',
  title: 'What We Do',
  description:
    'Comprehensive digital solutions tailored to your unique business challenges, delivered by experts who understand your industry.',
};

export const WHY_US_CONTENT = {
  subtitle: 'Why Choose Us',
  title: 'Why PixelMinds Consultancy',
  description:
    "We don't just build software—we create sustainable competitive advantages that transform how you do business.",
};

export const CONTACT_CONTENT = {
  title: 'Ready to Transform Your Business?',
  description:
    "Let's discuss how PixelMinds Consultancy can help you achieve your digital goals. Our team is ready to turn your vision into reality.",
  primaryCta: 'Contact Us',
  secondaryCta: 'Request a Consultation',
};

export const FOOTER_CONTENT = {
  tagline:
    "Innovating Digital Experiences. We're a UK-based technology consulting firm helping businesses thrive in the digital age.",
  quickLinksTitle: 'Quick Links',
  contactTitle: 'Get in Touch',
};
